<template>
  <!--成品价格查询-->
  <div>
    <s-pageheader title="成品价格查询" />
    <ak-model-filter-card model="parts" @search="search" @reset="reset" />
    <!--成品-->
    <ak-model-tree
      :treeSpan="4"
      model="batchingFinishProduct"
      treeModel="finishWorkShop"
      parentKey="parentNode"
      pointerToTree="proportion"
      treeTitle="车间检索"
      :action="edit"
      :modelTableProps="modelTableProps"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import check from '@/core/components/check'
import { mapState } from 'vuex'
export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      edit: { // 覆盖model的action
        create: false,
        edit: false,
        delete: false,
        formula: { // 此页只有查看功能，直接覆盖model中的配方功能
          type: 'row',
          text: '查看',
          component: check
        }
      },
      modelTableProps: {
        page: 1,
        filters: {}
      }
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
    search (filters) {
      this.$set(this.modelTableProps, 'filters', filters)
      this.$set(this.modelTableProps, 'page', 1)
    },
    reset () {
      this.$set(this.modelTableProps, 'filters', {})
      this.$set(this.modelTableProps, 'page', 1)
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .node-icon:before {
    content: none !important;
  }
</style>
